<script setup lang="ts">
import { ref, useTemplateRef } from "vue"

const props = withDefaults(
  defineProps<{
    icon: string
    label: string
    hint?: string
    note?: string
    accept?: string
    multiple?: boolean
  }>(),
  {
    hint: "Drop files here or click to browse",
    multiple: true,
  },
)

const emit = defineEmits<{
  files: [files: FileList]
}>()

const isDragging = ref(false)
const fileInput = useTemplateRef("fileInput")

function onDrop(event: DragEvent) {
  isDragging.value = false
  if (event.dataTransfer?.files?.length) emit("files", event.dataTransfer.files)
}

function onFilesSelected(event: Event) {
  const input = event.target as HTMLInputElement
  if (input.files?.length) emit("files", input.files)
  input.value = ""
}
</script>

<template>
  <div>
    <input
      ref="fileInput"
      type="file"
      :accept="accept"
      :multiple="multiple"
      class="hidden"
      @change="onFilesSelected"
    />

    <button
      type="button"
      class="flex w-full cursor-pointer flex-col items-center gap-2 rounded-lg border-2 border-dashed p-6 transition-colors"
      :class="
        isDragging
          ? 'border-primary text-primary bg-primary/5'
          : 'border-default text-muted hover:border-primary hover:text-primary'
      "
      @click="fileInput?.click()"
      @dragover.prevent="isDragging = true"
      @dragenter.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      @drop.prevent="onDrop"
    >
      <UIcon :name="icon" class="size-8" />
      <span class="text-sm font-medium">{{ label }}</span>
      <span class="text-xs">{{ hint }}</span>
      <span v-if="note" class="text-xs opacity-60">{{ note }}</span>
    </button>
  </div>
</template>
